var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container_rwd", attrs: { id: "home" } },
    [
      _c("main-slider", {
        attrs: { "cms-banner-section-id": "bs_HOMEPAGE_BETWEEN_BOKS" }
      }),
      _vm._v(" "),
      _c("section", { staticClass: "container px15" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-3 hidden-xs" }, [
            _c(
              "div",
              { staticClass: "left-banners" },
              [
                _vm.isCalculatorVisible
                  ? _c("Box", {
                      staticClass: "mt30",
                      attrs: {
                        categoryProps: _vm.getCurrentCategory.catalog,
                        box: _vm.box
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("cms-block-banner", {
                  attrs: {
                    identifier: "bs_HOMEPAGE_BANNER_LEFT",
                    padding: "100%"
                  }
                }),
                _vm._v(" "),
                _c("cms-block-banner", {
                  attrs: {
                    identifier: "bs_HOMEPAGE_BANNER_LEFT2",
                    padding: "100%"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-9" }, [
            _c(
              "div",
              { staticClass: "new-collection container px15" },
              [
                _c("promoted-offers", { staticClass: "visible-xs" }),
                _vm._v(" "),
                _vm.newProducts && _vm.newProducts.length
                  ? _c("products-slider", {
                      staticClass: "h_container-news",
                      attrs: {
                        title: _vm.$t("Everything new"),
                        products: _vm.newProducts,
                        config: _vm.configSliderNew,
                        categoryProps: _vm.categoryProduct.catalog,
                        isBadge: true,
                        id: "newprod"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.popularProducts && _vm.popularProducts.length
                  ? _c("products-slider", {
                      attrs: {
                        title: _vm.$t("Popular products"),
                        products: _vm.popularProducts,
                        config: _vm.configSliderPopular,
                        categoryProps: _vm.categoryProduct.catalog,
                        isBadge: true,
                        id: "popular"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.promotions && _vm.promotions.length
                  ? _c("products-slider", {
                      attrs: {
                        title: _vm.$t("Promotions of the day"),
                        products: _vm.promotions,
                        config: _vm.configSliderPromo,
                        categoryProps: _vm.categoryProduct.catalog,
                        isBadge: true,
                        id: "promo"
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container p15 hidden-xs" },
              [
                _c("cms-block-banner", {
                  attrs: {
                    identifier: "bs_HOMEPAGE_BANNER_BOTTOM",
                    "item-height": 120
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 visible-xs" }, [
            _c(
              "div",
              { staticClass: "left-banners" },
              [
                _vm.isCalculatorVisible
                  ? _c("Box", {
                      attrs: {
                        categoryProps: _vm.getCurrentCategory.catalog,
                        box: _vm.box
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("cms-block-banner", {
                  attrs: {
                    identifier: "bs_HOMEPAGE_BANNER_LEFT",
                    padding: "100%"
                  }
                }),
                _vm._v(" "),
                _c("cms-block-banner", {
                  attrs: {
                    identifier: "bs_HOMEPAGE_BANNER_LEFT2",
                    padding: "100%"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }